import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { StackedBarchartComponent } from './stackedbarchart.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
  ],
  exports: [StackedBarchartComponent],
  declarations: [StackedBarchartComponent]
})
export class StackedBarchartModule { }
